import BlogGridView from "../../../commonComponents/blogGridView";

const BlogInfiniteScrollContainer = () => {
  return <BlogGridView gridSize={3} type="infinite" />;
};

export default BlogInfiniteScrollContainer;
